<template>
    <section  v-if="hasPermissions(['Options-Bed-Numbers Read'])" class="view">
        <Breadcrumb :breadcrumb="breadcrumb"/>
        <h1 class="view__title title--1" v-html="title_page"/>
        <div class="view__description">
            <p class="view__description__text">
                This is the default bed spot for patient rooms. Enter the bed spot designation for your facility and click Save.
            </p>
        </div>

        <form @submit.prevent="form_submit()">
            <div class="col-md-5">
                <div class="row">
                    <div class="formdynamic__item col-md-6">
                        <div class="formdynamic__item__field">
                            <label for="Name:" class="modal-label active" v-html="`Bed #1`"/>
                            <input :maxlength="5" type="text" v-model="bed_numbers.bed_one"/>
                        </div>
                    </div>
                    <div class="formdynamic__item col-md-6">
                        <div class="formdynamic__item__field">
                            <label for="Code:" class="modal-label active" v-html="`Bed #2`"/>
                            <input :maxlength="5" type="text" v-model="bed_numbers.bed_two"/>
                        </div>
                    </div>
                    <div class="formdynamic__item col-md-6">
                        <div class="formdynamic__item__field">
                            <label for="Name:" class="modal-label active" v-html="`Bed #3`"/>
                            <input :maxlength="5" type="text" v-model="bed_numbers.bed_three"/>
                        </div>
                    </div>
                    <div class="formdynamic__item col-md-6">
                        <div class="formdynamic__item__field">
                            <label for="Code:" class="modal-label active" v-html="`Bed #4`"/>
                            <input :maxlength="5" type="text" v-model="bed_numbers.bed_four"/>
                        </div>
                    </div>
                    <div class="formdynamic__item col-md-6">
                        <div class="formdynamic__item__field">
                            <label for="Name:" class="modal-label active" v-html="`Bed #5`"/>
                            <input :maxlength="5" type="text" v-model="bed_numbers.bed_five"/>
                        </div>
                    </div>
                    <div class="formdynamic__item col-md-6" style="right: 0px;">
                        <div class="formdynamic__item__field">
                            <label for="Code:" class="modal-label active" v-html="`Bed #6`"/>
                            <input :maxlength="5" type="text" v-model="bed_numbers.bed_six"/>
                        </div>
                    </div>
                </div>
                <div v-if="hasPermissions(['Options-Bed-Numbers Write'])"  class="modal__buttons text-center text-md-right" style="margin-top:60px;">
                    <button class="mr-3 mb-3 modal__buttons__item" v-html="'Save'"/>
                </div>
            </div>
        </form>

        <WaitingModal/>
    </section>
    <div v-else>
        <UnauthorizedComponent :breadcrumb="breadcrumb"/>
    </div>
</template>

<script>

import Breadcrumb       from    '@/components/BreadcrumbComponent/Breadcrumb'
import WaitingModal     from    '@/components/WaitingModal'
import UnauthorizedComponent from   '@/components/UnauthorizedComponent'
import Resources        from    './resources'
import 'vuetify/dist/vuetify.min.css'

import { Notyf }            from    'notyf';
import 'notyf/notyf.min.css'; // for React and Vue
const notyf = new Notyf({
    duration: 8000,
});
export default {

    name: 'BedNumbers',

    components: {
        Breadcrumb,
        WaitingModal,
        UnauthorizedComponent,
    },

    data() {
        return {
            notyf,
            user:           this.get_user(),
            title_page:     'Bed numbers',
            rest_api:       `bed_facility_numbers`,
            breadcrumb:     Resources.breadcrumb,
            bed_numbers:    {},
        }
    },

    methods: {

        async form_submit()
        {
            this.loader(true)

            let route_api_rest = `${this.rest_api}/${this.bed_numbers.facility_id}`

            let response = await this.patch(route_api_rest, this.bed_numbers)

            if(response.status)
            {
                this.loader()
                notyf.success('Success')
            }
            else
            {
                this.loader()
                notyf.error('Error')
                this.error_handling(response)
            }
        },

        fill_data(data)
        {
            this.bed_numbers = data.bed_numbers
        },

    },

    async mounted()
    {
        if(this.hasPermissions(['Options-Bed-Numbers Read']) )
        {
            await this.api_request()
        }
    }

}
</script>